import './inputContainer.scss';

export const InputContainer = angular
    .module('checkout.components.inputContainer', [])
    .component('inputContainer', {
        bindings: {
            formInput: '<'
        },
        template: `
            <div class="checkout-input-container" ng-class="$ctrl.inputNeedsAttention()">
                <ng-transclude></ng-transclude>
            </div>
        `,
        transclude: true,
        controller: class InputContainerCtrl {
            inputNeedsAttention() {
                return {
                    'checkout-input-container--error': this.formInput && this.formInput.$invalid
                        && this.formInput.$dirty && this.formInput.$touched && this.formInput.$invalid
                };
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/inputContainer/inputContainer.js